import { render, staticRenderFns } from "./Basic.vue?vue&type=template&id=2afe9ce5&scoped=true"
import script from "./Basic.vue?vue&type=script&lang=js"
export * from "./Basic.vue?vue&type=script&lang=js"
import style0 from "./Basic.vue?vue&type=style&index=0&id=2afe9ce5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afe9ce5",
  null
  
)

export default component.exports